import React from "react";
import { useHistory, useLocation } from "react-router-dom";
import useWindowDimensions from "../../functions/windows";
import { IPaymentTracking } from "../../interfaces/paymentTracking";

export default function useChatPage() {
  const { state } = useLocation<{ item: IPaymentTracking }>();
  const [dataCard, setDataCard] = React.useState<IPaymentTracking>(state.item);
  const [isLoading, setIsLoading] = React.useState<boolean>(false);
  const { width } = useWindowDimensions();
  const history = useHistory();
  const handleSubmit = async () => {
    history.goBack();
  };
  const handleChangeTage = async (tags: string[]) => {
    const nData = { ...dataCard, summaryTags: tags };
    setDataCard(nData);
  };
  return {
    isLoading,
    setIsLoading,
    handleChangeTage,
    dataCard,
    handleSubmit,
    width
  };
}

